import { render, staticRenderFns } from "./UserNextBirthdayListItem.vue?vue&type=template&id=d2bb0fee&scoped=true&"
import script from "./UserNextBirthdayListItem.vue?vue&type=script&lang=js&"
export * from "./UserNextBirthdayListItem.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./UserNextBirthdayListItem.vue?vue&type=style&index=1&id=d2bb0fee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2bb0fee",
  null
  
)

export default component.exports